
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","viewBox":"0 0 570 300"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#003893","d":"M0 0h570v300H0z"}}),_c('path',{attrs:{"d":"M0 295.2V288L570 35v87.4z","fill":"#fff"}}),_c('path',{attrs:{"d":"M0 290.4v-4.8L570 4.8v58.8z","fill":"#dd7500"}}),_c('g',{attrs:{"fill":"#fff","transform":"translate(109.536 109.536)"}},[_c('g',{attrs:{"id":"b"}},[_c('path',{attrs:{"d":"M0-93L5.59 0H-5.59z"}}),_c('path',{attrs:{"id":"a","d":"M0-66.588L6.824 0H-6.824z","transform":"rotate(15)"}}),_c('use',{attrs:{"xlink:href":"#a","transform":"rotate(15)"}}),_c('use',{attrs:{"xlink:href":"#a","transform":"rotate(30)"}}),_c('use',{attrs:{"xlink:href":"#a","transform":"rotate(45)"}}),_c('use',{attrs:{"xlink:href":"#a","transform":"rotate(60)"}})]),_c('use',{attrs:{"xlink:href":"#b","transform":"rotate(90)"}}),_c('use',{attrs:{"xlink:href":"#b","transform":"rotate(180)"}}),_c('use',{attrs:{"xlink:href":"#b","transform":"rotate(270)"}})])])
          )
        }
      }
    